import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { MaterialIcon } from 'shared/ui/MaterialIcon';

interface ManagerMenuLinkProps {
  title: string;
  href: string;
  iconName: string;
  search?: string;
  isSmallSize?: boolean;
}

export function ManagerMenuLink({ title, href, iconName, search, isSmallSize }: ManagerMenuLinkProps) {
  const location = useLocation();
  const isSelected = location.pathname.startsWith(href);
  const linkClass = classNames(
    'mb-2 select-none text-base flex items-center py-2 rounded-md hover:bg-white hover:text-slate-900 [&>span]:hover:text-slate-700 [&>span]:text-slate-100',
    isSelected ? 'font-semibold text-slate-900 bg-white [&>span]:text-slate-700' : 'text-slate-25',
    isSmallSize ? 'justify-center' : 'px-4'
  );

  const samePath = href === location.pathname;

  const selectedHref = isSelected && samePath ? `${href}${location.search}` : `${href}${search ?? ''}`;

  return (
    <Link to={selectedHref}>
      <div className={linkClass}>
        <MaterialIcon>{iconName}</MaterialIcon>
        {!isSmallSize && <div className="ml-3 border-transparent text-sm font-semibold">{title}</div>}
      </div>
    </Link>
  );
}
